import React, { useEffect, useState } from "react";
import { Button, Paper, Stack, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import { updateData } from "../../actions/actionItems";
import { buttonValues } from "../../../constants/Types";
import { SnCPropertyEnum } from "../../../constants/NavbarList";
import { golfTooltipHeaders } from "../../../constants/TooltipInformation";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";

const SnCProformaInvoiceSetup = ({
  data,
  fieldValues,
}: {
  data: (value: any) => void;
  fieldValues: any;
}) => {
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    fieldValues && setItems(Array.isArray(fieldValues) ? fieldValues : []);
  }, []);

  useEffect(() => {
    data(items);
  }, [items]);

  const addItem = () => {
    setItems((prev) =>
      updateData(
        prev?.length ? [...prev, { id: (prev?.length ?? 0) + 1 }] : [{ id: 1 }],
      ),
    );
  };

  return (
    <Stack direction="column" gap="10px">
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
        }}
      >
        <Stack
          direction="row"
          width="100%"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6" sx={textStyle}>
            Proforma Invoice Setup
            <Tooltip
              title={tooltipComponent(
                golfTooltipHeaders?.categoryGroup ?? "Proforma Invoice Setup",
              )}
            >
              <InfoIcon fontSize="small" />
            </Tooltip>
          </Typography>
        </Stack>
        <Typography variant="body2" sx={{ color: "gray", marginBottom: 2 }}>
          No columns defined
        </Typography>
        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{
              cursor: "pointer",
              border: "1px solid gray",
              borderRadius: "10px",
              background: "darkgreen",
              color: "white",
            }}
            onClick={addItem}
          >
            {buttonValues.ADD} Row
          </Button>
        </Stack>
        <Stack direction="column" gap="10px" mt={4}>
          <Typography variant="h6">
            Proforma Invoice Setup ({items?.length ?? 0})
          </Typography>
          {items?.length ? (
            <Typography variant="body2">{items.length} row(s) added</Typography>
          ) : (
            <Typography variant="body2">No Proforma Invoice Setup</Typography>
          )}
        </Stack>
      </Paper>
    </Stack>
  );
};

export default SnCProformaInvoiceSetup;
